import { render, staticRenderFns } from "./QUserMenu.vue?vue&type=template&id=1bffbe46&scoped=true&"
import script from "./QUserMenu.vue?vue&type=script&lang=js&"
export * from "./QUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./QUserMenu.vue?vue&type=style&index=0&id=1bffbe46&prod&lang=scss&"
import style1 from "./QUserMenu.vue?vue&type=style&index=1&id=1bffbe46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bffbe46",
  null
  
)

export default component.exports